import React, { useState } from 'react';
import s from './Footer.Style';
import { useNavigate } from 'react-router-dom';
import MainInquiryPopUp from '../../main/components/MainInquiryPopUpModal';

const Footer = () => {
  const navigate = useNavigate();
  const [emailAlert, setEmailAlert] = useState(false);
  const [showInquiryPopUp, setShowInquiryPopUp] = useState(false);
  return (
    <s.footerContainer
      style={
        window.location.pathname ===
        '/promotion/%EB%95%85%EC%A7%91%EA%B3%A0%EC%98%A5%EC%85%98-%EC%98%A4%ED%94%88%EA%B8%B0%EB%85%90-%EC%9D%B4%EB%B2%A4%ED%8A%B8'
          ? { background: '#222222' }
          : {}
      }
    >
      <s.footerTitleBox>
        <img src="/assets/images/logo/zipgoai_logo_mobile_footer2.svg" alt="" />
      </s.footerTitleBox>
      <s.companyInfo>
        <div
          onClick={() => {
            navigate('/companyinfo');
          }}
        >
          회사소개
        </div>
        <s.Divider />
        <div
          onClick={() => {
            navigate('/terms/service');
          }}
        >
          이용약관
        </div>
        <s.Divider />

        <div
          onClick={() => {
            navigate('/terms/location');
          }}
        >
          위치기반서비스 이용약관
        </div>
        <s.Divider />
        <div
          onClick={() => {
            navigate('/terms/privacy');
          }}
        >
          개인정보처리방침
        </div>
        <s.Divider />
        <div
          onClick={() => {
            setEmailAlert(true);
          }}
        >
          이메일 무단수집거부
        </div>
        <s.Divider />

        <div
          onClick={() => {
            setShowInquiryPopUp(true);
          }}
        >
          사업제휴
        </div>
      </s.companyInfo>
      <s.infoContainer>
        <s.infoText>
          <span>제호 : 땅집고</span> <s.Divider />
          <span>상호 : (주)엠딕</span>
          <s.Divider />
          <span>대표 : 유하용</span>
        </s.infoText>
        <s.infoText>사업자등록번호 : 478-88-01291</s.infoText>
        <s.infoText>주소 : 서울특별시 중구 세종대로 21길 22, 2층</s.infoText>
        <s.infoText>
          <span>제호 : 땅집고옥션</span> <s.Divider />
          <span>상호 : 트랜스파머(주)</span>
          <s.Divider />
          <span>대표 : 김기현</span>
        </s.infoText>
        <s.infoText>사업자등록번호 : 507-87-02631</s.infoText>
        <s.infoText>
          주소 : (본점)강원특별자치도 춘천시 춘천로 188, 210-C75호 /
          (지점)서울특별시 서초구 매헌로 24 NH농협 디지털혁신캠퍼스 5층
        </s.infoText>
        <s.infoText>대표전화 : 02)555-2822 (평일 10:00~18:00)</s.infoText>
        <s.infoText>
          E-mail : biz@transfarmer.co.kr (평일 10:00~18:00)
        </s.infoText>
        <s.infoText>개인정보보호책임자 : 박성필</s.infoText>
      </s.infoContainer>
      <s.infoText>
        (주)엠딕과 트랜스파머(주)는 땅집고옥션 서비스의 공동사업자로
        트랜스파머(주)는 해당 홈페이지 운영을 담당하고 있습니다.
      </s.infoText>
      <s.infoText>COPYRIGHTⓒ 땅집고옥션, ALL RIGHT RESERVED.</s.infoText>
      {emailAlert && (
        <s.EmailContainer
          onClick={(e) => {
            e.stopPropagation(); // 이벤트 전파 방지
            setEmailAlert(false);
          }}
        >
          <s.EmailBox
            onClick={(e) => {
              e.stopPropagation(); // 이벤트 전파 방지
            }}
          >
            <s.EmailInner>
              <div>
                <span>이메일 무단수집 금지 안내</span>
              </div>
              <div>
                당사 웹사이트(https://zipgoai.com/)에 게시된 이메일주소를
                무단으로 수집하는 것을 금지합니다. 이메일주소 수집 프로그램 또는
                기타 기술적 장치를 통해 무단으로 이메일주소를 수집할 경우,
                정보통신망이용촉진 및 정보보호 등에 관한 법률 제50조의2,
                제65조의2에 의거하여 1천만원 이하의 벌금형이 부과될 수 있음을
                알려드립니다.
              </div>
            </s.EmailInner>
            <s.ButtonBox
              onClick={(e) => {
                setEmailAlert(false);
              }}
            >
              확인
            </s.ButtonBox>
          </s.EmailBox>
        </s.EmailContainer>
      )}
      {showInquiryPopUp && (
        <MainInquiryPopUp
          showInquiryPopUp={showInquiryPopUp}
          setShowInquiryPopUp={setShowInquiryPopUp}
          inquiryType={'Partnership'} // inquiryType prop 전달
        ></MainInquiryPopUp>
      )}
    </s.footerContainer>
  );
};
export default Footer;
